import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import productReducer from "./productReducer";
import productSuiteReducer from "./productSuiteReducer";
import productGroupReducer from "./productGroupReducer";
import phaseReducer from "./phaseReducer";
import versionReducer from "./versionReducer";
import userReducer from "./userReducer";
import activityReducer from "./activityReducer";

export default (history) =>
  combineReducers({
    productState: productReducer,
    productSuiteState: productSuiteReducer,
    productGroupState: productGroupReducer,
    phaseState: phaseReducer,
    versionState: versionReducer,
    userState: userReducer,
    activityState: activityReducer,
    router: connectRouter(history),
  });
